import React, { useState } from "react";
import {
  Navbar,
  Container,
  Image,
  Nav,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import configuration from "react-global-configuration";

const Sidebar = (props) => {
  const location = useLocation();
  const profile = useSelector((state) => state.admin.profile);

  return (
    <>
      <div className={`admin-ui-sidebar`}>
        <div className="admin-ui-sidebar-collapse">
          <div className="admin-ui-collapse-logo-sec">
            <div className="admin-user-details">
              <Image
                className="admin-user-img"
                src={window.location.origin + "/logo192.png"}
              />
            </div>
          </div>
          <div className="admin-ui-collapse-body">
            <ul className="admin-ui-sidebar-list list-unstyled">
              <li>
                <Link
                  to="/"
                  className={`${location.pathname === "/" && "active"}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="#111"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.667"
                      d="M17.5 12.841v2.992a1.666 1.666 0 01-1.666 1.667h-2.992a1.175 1.175 0 01-.834-2.009l3.476-3.475a1.176 1.176 0 012.016.825zM5.417 8.333a2.917 2.917 0 100-5.833 2.917 2.917 0 000 5.833zM15.833 2.5h-2.5c-.92 0-1.666.746-1.666 1.667v2.5c0 .92.746 1.666 1.666 1.666h2.5c.92 0 1.667-.746 1.667-1.666v-2.5c0-.92-.746-1.667-1.667-1.667zM6.667 11.667h-2.5c-.92 0-1.667.746-1.667 1.666v2.5c0 .92.746 1.667 1.667 1.667h2.5c.92 0 1.666-.746 1.666-1.667v-2.5c0-.92-.746-1.666-1.666-1.666z"
                    ></path>
                  </svg>
                </Link>
              </li>
              {profile.data.kyc_status == 3 && (
                <React.Fragment>
                  {profile.data.payin_access == 1 && (
                    <>
                      {/* <li>
                        <Link
                          to="/api-reference"
                          className={`${
                            location.pathname.includes("/api-reference") &&
                            "active"
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 20 20"
                          >
                            <g clipPath="url(#clip0_22_242)">
                              <path d="M0 0H20V20H0z"></path>
                              <path
                                fill="#111"
                                stroke="#111"
                                strokeWidth="0.5"
                                d="M8.593 13.538l-2.93.099c-1.766.034-3.23-1.49-3.27-3.401C2.353 8.36 3.7 6.8 5.428 6.716l2.933-.1c.35-.012.625-.33.612-.71-.013-.38-.308-.679-.66-.667l-2.931.1C2.916 5.424.99 7.658 1.08 10.33c.091 2.672 2.164 4.77 4.63 4.686l2.931-.099c.35-.018.62-.341.6-.721-.018-.37-.304-.66-.646-.655l-.002-.002h0zM18.947 9.704c-.04-1.284-.551-2.5-1.422-3.377-.866-.882-2.02-1.354-3.204-1.31l-2.933.096c-.351.012-.626.33-.613.71.013.38.307.679.659.667l2.932-.097a3.055 3.055 0 012.293.937c1.292 1.31 1.365 3.5.163 4.894a3.077 3.077 0 01-2.224 1.089l-2.93.099c-.352.011-.626.33-.613.71.012.38.307.679.659.667l2.93-.098c2.464-.086 4.39-2.316 4.303-4.987z"
                              ></path>
                              <path
                                fill="#111"
                                stroke="#111"
                                strokeWidth="0.5"
                                d="M12.687 9.235l-5.392.182c-.35.005-.63.317-.623.698.006.38.296.684.648.679a.54.54 0 00.022-.001l5.39-.182c.351-.018.62-.341.601-.72-.018-.371-.304-.661-.646-.656z"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_22_242">
                                <path d="M0 0H20V20H0z"></path>
                              </clipPath>
                            </defs>
                          </svg>
                        </Link>
                      </li> */}
                      {/* <li>
                  <Link to="/api-payment" className={`${location.pathname.includes("/api-payment") && "active"}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <g clipPath="url(#clip0_22_242)">
                        <path d="M0 0H20V20H0z"></path>
                        <path
                          fill="#111"
                          stroke="#111"
                          strokeWidth="0.5"
                          d="M8.593 13.538l-2.93.099c-1.766.034-3.23-1.49-3.27-3.401C2.353 8.36 3.7 6.8 5.428 6.716l2.933-.1c.35-.012.625-.33.612-.71-.013-.38-.308-.679-.66-.667l-2.931.1C2.916 5.424.99 7.658 1.08 10.33c.091 2.672 2.164 4.77 4.63 4.686l2.931-.099c.35-.018.62-.341.6-.721-.018-.37-.304-.66-.646-.655l-.002-.002h0zM18.947 9.704c-.04-1.284-.551-2.5-1.422-3.377-.866-.882-2.02-1.354-3.204-1.31l-2.933.096c-.351.012-.626.33-.613.71.013.38.307.679.659.667l2.932-.097a3.055 3.055 0 012.293.937c1.292 1.31 1.365 3.5.163 4.894a3.077 3.077 0 01-2.224 1.089l-2.93.099c-.352.011-.626.33-.613.71.012.38.307.679.659.667l2.93-.098c2.464-.086 4.39-2.316 4.303-4.987z"
                        ></path>
                        <path
                          fill="#111"
                          stroke="#111"
                          strokeWidth="0.5"
                          d="M12.687 9.235l-5.392.182c-.35.005-.63.317-.623.698.006.38.296.684.648.679a.54.54 0 00.022-.001l5.39-.182c.351-.018.62-.341.601-.72-.018-.371-.304-.661-.646-.656z"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_22_242">
                          <path d="M0 0H20V20H0z"></path>
                        </clipPath>
                      </defs>
                    </svg>
                  </Link>
                </li> */}
                      {/* <li>
                        <Link
                          to="/transactions"
                          className={`${
                            location.pathname == "/transactions" && "active"
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 20 20"
                          >
                            <path
                              stroke="#111"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M4.615 10L3.077 8.328 1.539 10M15.385 10l1.538 1.672L18.462 10"
                            ></path>
                            <path
                              stroke="#111"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M16.923 11.672V10a7.975 7.975 0 00-1.28-4.334c-.827-1.267-1.996-2.224-3.345-2.74a6.4 6.4 0 00-4.187-.14c-1.376.423-2.597 1.3-3.496 2.508M3.077 8.328V10a7.975 7.975 0 001.28 4.334c.828 1.267 1.996 2.224 3.345 2.74a6.4 6.4 0 004.187.14c1.376-.423 2.597-1.3 3.496-2.508"
                            ></path>
                          </svg>
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          to="/invoice-payment"
                          className={`${
                            location.pathname.includes("/invoice-payment") &&
                            "active"
                          }`}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 20 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.5 9.16665C2.5 5.70968 2.5 3.9812 3.47631 2.90725C4.45262 1.83331 6.02397 1.83331 9.16667 1.83331H10.8333C13.976 1.83331 15.5474 1.83331 16.5237 2.90725C17.5 3.9812 17.5 5.70968 17.5 9.16665V12.8333C17.5 16.2902 17.5 18.0188 16.5237 19.0927C15.5474 20.1666 13.976 20.1666 10.8333 20.1666H9.16667C6.02397 20.1666 4.45262 20.1666 3.47631 19.0927C2.5 18.0188 2.5 16.2902 2.5 12.8333V9.16665Z"
                              stroke="#252525"
                              stroke-width="2"
                            />
                            <path
                              d="M9.3252 12.3223L10.6748 11.3444"
                              stroke="#252525"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <path
                              d="M10.1173 14.8357L9.7317 15.1151C8.4539 16.0409 6.76131 15.8851 5.95121 14.767C5.1411 13.6489 5.52024 11.992 6.79804 11.0662L7.18365 10.7868"
                              stroke="#252525"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <path
                              d="M9.88281 8.83099L10.2684 8.5516C11.5462 7.62576 13.2388 7.7816 14.0489 8.89967C14.859 10.0177 14.4799 11.6747 13.2021 12.6005L12.8165 12.8799"
                              stroke="#252525"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                          </svg>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/invoice-transactions"
                          className={`${
                            location.pathname.includes(
                              "invoice-transactions"
                            ) && "active"
                          }`}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 20 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.5 9.16665C2.5 5.70968 2.5 3.9812 3.47631 2.90725C4.45262 1.83331 6.02397 1.83331 9.16667 1.83331H10.8333C13.976 1.83331 15.5474 1.83331 16.5237 2.90725C17.5 3.9812 17.5 5.70968 17.5 9.16665V12.8333C17.5 16.2902 17.5 18.0188 16.5237 19.0927C15.5474 20.1666 13.976 20.1666 10.8333 20.1666H9.16667C6.02397 20.1666 4.45262 20.1666 3.47631 19.0927C2.5 18.0188 2.5 16.2902 2.5 12.8333V9.16665Z"
                              stroke="#252525"
                              stroke-width="2"
                            />
                            <path
                              d="M13.3334 8.91665H6.66675M6.66675 8.91665L8.95841 6.83331M6.66675 8.91665L8.95841 11"
                              stroke="#252525"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.66675 13.0833H13.3334M13.3334 13.0833L11.0417 11M13.3334 13.0833L11.0417 15.1667"
                              stroke="#252525"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Link>
                      </li>
                    </>
                  )}
                  {profile.data.payout_access == 1 && (
                    <>
                      {/* <li>
                        <Link
                          to="/payout-api"
                          className={`${
                            location.pathname == "/payout-api" && "active"
                          }`}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.259 22.322C11.2035 22.4855 9.1344 22.0362 7.31793 21.0321C5.50145 20.028 4.02064 18.515 3.06599 16.6876C2.11133 14.8602 1.72649 12.802 1.96095 10.7779C2.19541 8.75367 3.03846 6.85604 4.38165 5.32903C5.72485 3.80202 7.50676 2.71548 9.49819 2.20916C11.4896 1.70284 13.5995 1.7999 15.5564 2.48786C17.5134 3.17582 19.2278 4.42321 20.4794 6.06958C21.7309 7.71596 22.4622 9.68602 22.5792 11.7264"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M19.6954 20.6766L22.1504 18.179M22.1504 18.179L19.6823 15.6766M22.1504 18.179L14.1504 18.2005"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14.5291 9H12.7039C12.4339 9 12.215 9.21889 12.215 9.48889V13.6608C12.215 13.9308 12.4339 14.1497 12.7039 14.1497C12.9739 14.1497 13.1928 13.9308 13.1928 13.6608V12.5852H14.5291C15.5176 12.5852 16.3217 11.7811 16.3217 10.7926C16.3217 9.80413 15.5176 9 14.5291 9ZM14.5291 11.6074H13.1928V9.97779H14.5291C14.9784 9.97779 15.3439 10.3433 15.3439 10.7926C15.3439 11.2419 14.9784 11.6074 14.5291 11.6074Z"
                              fill="black"
                            />
                            <path
                              d="M10.0327 9.31726C9.96111 9.12646 9.77872 9 9.57495 9H9.05347C8.84969 9 8.66724 9.1264 8.59573 9.31726L7.03127 13.4891C6.93643 13.7419 7.06458 14.0237 7.31737 14.1186C7.57016 14.2134 7.85196 14.0853 7.94681 13.8325L8.21889 13.1067H10.4095L10.6816 13.8324C10.7552 14.0287 10.9415 14.1498 11.1394 14.1498C11.1964 14.1498 11.2545 14.1398 11.311 14.1186C11.5638 14.0238 11.6919 13.7419 11.5971 13.4891L10.0327 9.31726ZM8.58556 12.1289L9.31421 10.1859L10.0429 12.1289H8.58556Z"
                              fill="black"
                            />
                            <path
                              d="M17.3972 9C17.1272 9 16.9083 9.21889 16.9083 9.48889V13.6608C16.9083 13.9308 17.1272 14.1497 17.3972 14.1497C17.6672 14.1497 17.8861 13.9308 17.8861 13.6608V9.48889C17.8861 9.21889 17.6672 9 17.3972 9Z"
                              fill="black"
                            />
                          </svg>
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          to="/payout-transactions"
                          className={`${
                            location.pathname == "/payout-transactions" &&
                            "active"
                          }`}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.2003 20.4217C10.3302 20.5704 8.44782 20.1617 6.79524 19.2482C5.14266 18.3347 3.79547 16.9582 2.92695 15.2956C2.05843 13.6331 1.70831 11.7607 1.92162 9.91914C2.13492 8.0776 2.9019 6.35118 4.12391 4.96195C5.34591 3.57272 6.96704 2.58422 8.77879 2.12358C10.5905 1.66295 12.51 1.75126 14.2904 2.37714C16.0708 3.00302 17.6306 4.13786 18.7691 5.63569C19.9077 7.13351 20.5731 8.92582 20.6796 10.7821"
                              stroke="black"
                              stroke-width="1.81954"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.7446 9.90897C12.5957 10.4942 12.0031 10.94 11.2823 10.94H10.3407C9.94146 10.94 9.59923 11.2298 9.59923 11.6092C9.59923 11.781 9.67412 11.9508 9.811 12.0729L12.553 14.6112C12.553 14.6113 12.5531 14.6113 12.5532 14.6114C12.6576 14.709 12.7984 14.7611 12.9426 14.7611C13.1764 14.7611 13.3603 14.6361 13.4426 14.4649C13.5257 14.2919 13.5011 14.0778 13.3322 13.9202L13.332 13.92L11.1825 11.9307H11.2823C12.5908 11.9307 13.6899 11.0554 13.8554 9.90897H14.2391C14.5291 9.90897 14.7849 9.69606 14.7849 9.41365C14.7849 9.13124 14.5291 8.91833 14.2391 8.91833H13.754C13.6742 8.69279 13.557 8.48172 13.4083 8.2916H14.2391C14.5291 8.2916 14.7849 8.07869 14.7849 7.79628C14.7849 7.51387 14.5291 7.30096 14.2391 7.30096H9.69021C9.40014 7.30096 9.14434 7.51387 9.14434 7.79628C9.14434 8.07869 9.40014 8.2916 9.69021 8.2916H11.2823C11.8255 8.2916 12.2945 8.54505 12.557 8.91833H9.69021C9.40014 8.91833 9.14434 9.13124 9.14434 9.41365C9.14434 9.69606 9.40014 9.90897 9.69021 9.90897H12.7446Z"
                              fill="black"
                              stroke="black"
                              stroke-width="0.181954"
                            />
                            <path
                              d="M18.0559 18.9248L20.2894 16.6525M20.2894 16.6525L18.044 14.3759M20.2894 16.6525L13.0112 16.6721"
                              stroke="black"
                              stroke-width="1.81954"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          to="/deposit-payout"
                          className={`${
                            location.pathname == "/deposit-payout" && "active"
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fillRule="evenodd"
                            strokeLinejoin="round"
                            strokeMiterlimit="2"
                            clipRule="evenodd"
                            viewBox="0 0 64 64"
                            width="24"
                            height="24"
                          >
                            <path
                              d="M2021.99 228.159c3.88.286 12.15.841 18.01.841 5.13 0 10.58-1.178 15.35-2.031 4.12-.737 11.64-3.463 13.1-4.003 1.52-.563 1.55-1.962 1.55-1.967a6.525 6.525 0 00-7.61-6.431c-3.48.546-6.52 1.248-11.54 1.41a5.652 5.652 0 00-4.88-4.327l-3.68-.409a6.55 6.55 0 01-2.91-1.06c-.67-.447-1.44-.961-2.16-1.417a10.452 10.452 0 00-6.24-1.738c-4.64.11-7.8.601-10.56.915l-.18-.185A5.988 5.988 0 002016 206h-4c-1.11 0-2 .895-2 2v16c0 1.591.63 3.117 1.76 4.243A5.988 5.988 0 002016 230h4c1.05 0 1.91-.811 1.99-1.841zm-3.99-2.174V226h-2c-.53 0-1.04-.211-1.41-.586A1.984 1.984 0 012014 224v-14h2c.53 0 1.04.211 1.41.586.38.375.59.884.59 1.414zm33-6.01V220c0 .996-.73 1.841-1.72 1.98-3.82.541-7.67.599-11.58-.003a2.013 2.013 0 01-1.68-2.281 2.002 2.002 0 012.28-1.673c2.94.451 5.83.486 8.7.203v-.958a1.65 1.65 0 00-1.47-1.641l-3.68-.409a10.536 10.536 0 01-4.69-1.708c-.65-.436-1.41-.939-2.11-1.384l-.03-.021a6.455 6.455 0 00-3.88-1.081l-.04.001c-3.87.091-6.69.46-9.1.757V224.149c3.67.275 12.08.851 18 .851 4.89 0 10.09-1.155 14.65-1.969 3.14-.561 8.36-2.356 11-3.305a2.302 2.302 0 00-.55-.655 2.525 2.525 0 00-2.08-.553c-3.63.569-6.8 1.287-12.02 1.457z"
                              transform="translate(-2008 -168)"
                            ></path>
                            <path
                              d="M2037.43 202.569c3.28 4.502 8.58 7.431 14.57 7.431 9.93 0 18-8.066 18-18 0-5.987-2.93-11.294-7.43-14.568-3.27-4.503-8.58-7.432-14.57-7.432-9.93 0-18 8.066-18 18 0 5.987 2.93 11.296 7.43 14.569zm22.42-22.159A13.922 13.922 0 002052 178c-7.73 0-14 6.273-14 14 0 2.908.89 5.611 2.41 7.851.09.099.16.206.22.318A13.986 13.986 0 002052 206c7.73 0 14-6.273 14-14 0-4.679-2.3-8.826-5.83-11.368a2.13 2.13 0 01-.32-.222zm-2.85.59h-10c-1.1 0-2 .896-2 2s.9 2 2 2h3c1.31 0 2.42.835 2.83 2H2047c-1.1 0-2 .896-2 2s.9 2 2 2h5.83c-.41 1.165-1.52 2-2.83 2h-3c-.81 0-1.54.487-1.85 1.235-.31.747-.14 1.607.44 2.179l7 7a1.99 1.99 0 002.82 0c.79-.78.79-2.048 0-2.828l-3.77-3.779a7.006 7.006 0 005.29-5.807h.07c1.1 0 2-.896 2-2s-.9-2-2-2h-.07a7.089 7.089 0 00-.6-2h.67c1.1 0 2-.896 2-2s-.9-2-2-2zm-7.13-6.875A13.82 13.82 0 002048 174c-7.73 0-14 6.273-14 14 0 .635.04 1.261.12 1.873.98-8.235 7.52-14.777 15.75-15.748z"
                              transform="translate(-2008 -168) translate(-2)"
                            ></path>
                          </svg>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/merchant-payout"
                          className={`${
                            location.pathname == "/merchant-payout" && "active"
                          }`}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.2003 20.4217C10.3302 20.5704 8.44782 20.1617 6.79524 19.2482C5.14266 18.3347 3.79547 16.9582 2.92695 15.2956C2.05843 13.6331 1.70831 11.7607 1.92162 9.91914C2.13492 8.0776 2.9019 6.35118 4.12391 4.96195C5.34591 3.57272 6.96704 2.58422 8.77879 2.12358C10.5905 1.66295 12.51 1.75126 14.2904 2.37714C16.0708 3.00302 17.6306 4.13786 18.7691 5.63569C19.9077 7.13351 20.5731 8.92582 20.6796 10.7821"
                              stroke="black"
                              stroke-width="1.81954"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.7446 9.90897C12.5957 10.4942 12.0031 10.94 11.2823 10.94H10.3407C9.94146 10.94 9.59923 11.2298 9.59923 11.6092C9.59923 11.781 9.67412 11.9508 9.811 12.0729L12.553 14.6112C12.553 14.6113 12.5531 14.6113 12.5532 14.6114C12.6576 14.709 12.7984 14.7611 12.9426 14.7611C13.1764 14.7611 13.3603 14.6361 13.4426 14.4649C13.5257 14.2919 13.5011 14.0778 13.3322 13.9202L13.332 13.92L11.1825 11.9307H11.2823C12.5908 11.9307 13.6899 11.0554 13.8554 9.90897H14.2391C14.5291 9.90897 14.7849 9.69606 14.7849 9.41365C14.7849 9.13124 14.5291 8.91833 14.2391 8.91833H13.754C13.6742 8.69279 13.557 8.48172 13.4083 8.2916H14.2391C14.5291 8.2916 14.7849 8.07869 14.7849 7.79628C14.7849 7.51387 14.5291 7.30096 14.2391 7.30096H9.69021C9.40014 7.30096 9.14434 7.51387 9.14434 7.79628C9.14434 8.07869 9.40014 8.2916 9.69021 8.2916H11.2823C11.8255 8.2916 12.2945 8.54505 12.557 8.91833H9.69021C9.40014 8.91833 9.14434 9.13124 9.14434 9.41365C9.14434 9.69606 9.40014 9.90897 9.69021 9.90897H12.7446Z"
                              fill="black"
                              stroke="black"
                              stroke-width="0.181954"
                            />
                            <path
                              d="M18.0559 18.9248L20.2894 16.6525M20.2894 16.6525L18.044 14.3759M20.2894 16.6525L13.0112 16.6721"
                              stroke="black"
                              stroke-width="1.81954"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Link>
                      </li>
                    </>
                  )}
                  {profile.data.payin_access == 1 && (
                    <>
                      <li>
                        <Link
                          to="/settlement"
                          className={`${
                            location.pathname.includes("settlement") && "active"
                          }`}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_553_5475)">
                              <path
                                d="M9.99999 19.1667C15.0626 19.1667 19.1667 15.0626 19.1667 9.99999C19.1667 4.93738 15.0626 0.833328 9.99999 0.833328C4.93738 0.833328 0.833328 4.93738 0.833328 9.99999C0.833328 15.0626 4.93738 19.1667 9.99999 19.1667Z"
                                stroke="#111111"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10.8608 9.1C10.7015 9.8446 10.0398 10.4 9.25 10.4H8.215C7.76477 10.4 7.4 10.7648 7.4 11.215C7.4 11.4198 7.4793 11.6253 7.62855 11.775L10.6425 14.9139C10.6426 14.9139 10.6426 14.914 10.6427 14.9141C10.7566 15.0339 10.9128 15.1 11.075 15.1C11.6033 15.1 11.8728 14.4694 11.5074 14.086L11.5071 14.0857L9.1197 11.6H9.25C10.7013 11.6 11.9035 10.5073 12.0797 9.1H12.5C12.8302 9.1 13.1 8.83023 13.1 8.5C13.1 8.16977 12.8302 7.9 12.5 7.9H11.9695C11.8794 7.61162 11.7448 7.34192 11.5728 7.1H12.5C12.8302 7.1 13.1 6.83023 13.1 6.5C13.1 6.16977 12.8302 5.9 12.5 5.9H7.5C7.16977 5.9 6.9 6.16977 6.9 6.5C6.9 6.83023 7.16977 7.1 7.5 7.1H9.25C9.8517 7.1 10.3752 7.42128 10.663 7.9H7.5C7.16977 7.9 6.9 8.16977 6.9 8.5C6.9 8.83023 7.16977 9.1 7.5 9.1H10.8608Z"
                                fill="black"
                                stroke="black"
                                stroke-width="0.2"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_553_5475">
                                <rect width="20" height="20" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/bank-accounts"
                          className={`${
                            location.pathname.includes("bank-account") &&
                            "active"
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 20 20"
                          >
                            <path
                              stroke="#111"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M2.5 17.5h15M4.184 10v5M10.009 10v5M15.85 10v5M3.084 5.55l5.358-2.675a3.492 3.492 0 013.15 0l5.35 2.667a1.033 1.033 0 01-.458 1.958H3.542a1.025 1.025 0 01-.458-1.95z"
                            ></path>
                          </svg>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/customise-payment"
                          className={`${
                            location.pathname.includes("customise-payment") &&
                            "active"
                          }`}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.7193 10.6329C18.1883 10.0209 17.2631 10.0209 16.7326 10.6329L13.0435 14.8842V17.1739H15.0301L18.7188 12.9226C18.9843 12.6166 19.1304 12.2102 19.1304 11.7774C19.1304 11.3446 18.9843 10.9383 18.7193 10.6329ZM18.0568 12.159L14.6425 16.0946H13.9799V15.331L17.3947 11.3959C17.5712 11.1919 17.8798 11.1919 18.0568 11.3959C18.1453 11.4974 18.194 11.6328 18.194 11.7774C18.194 11.9221 18.1453 12.057 18.0568 12.159Z"
                              fill="black"
                              stroke="black"
                              stroke-width="0.5"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M4.14468 1H15.0615C16.8664 1 18.3365 2.59285 18.3365 4.54842V8.53447C18.099 8.46417 17.8562 8.40927 17.6088 8.37075V7.3083H1.59742V14.7994C1.59742 16.3213 2.74004 17.5593 4.14468 17.5593H10.626C10.6908 17.8287 10.7686 18.0919 10.8587 18.3478H4.14468C2.33976 18.3478 0.869629 16.755 0.869629 14.7994V4.54842C0.869629 2.59285 2.33976 1 4.14468 1ZM15.0615 1.78854H4.14468C2.74004 1.78854 1.59742 3.02654 1.59742 4.54842V6.51976H17.6088V4.54842C17.6088 3.02654 16.4661 1.78854 15.0615 1.78854Z"
                              fill="black"
                            />
                            <path
                              d="M18.3365 8.53447L18.1946 9.01391L18.8365 9.2039V8.53447H18.3365ZM17.6088 8.37075H17.1088V8.79893L17.5318 8.8648L17.6088 8.37075ZM17.6088 7.3083H18.1088V6.8083H17.6088V7.3083ZM1.59742 7.3083V6.8083H1.09742V7.3083H1.59742ZM10.626 17.5593L11.1122 17.4424L11.0201 17.0593H10.626V17.5593ZM10.8587 18.3478V18.8478H11.5648L11.3304 18.1818L10.8587 18.3478ZM1.59742 6.51976H1.09742V7.01976H1.59742V6.51976ZM17.6088 6.51976V7.01976H18.1088V6.51976H17.6088ZM15.0615 0.5H4.14468V1.5H15.0615V0.5ZM18.8365 4.54842C18.8365 2.3552 17.1795 0.5 15.0615 0.5V1.5C16.5533 1.5 17.8365 2.83049 17.8365 4.54842H18.8365ZM18.8365 8.53447V4.54842H17.8365V8.53447H18.8365ZM17.5318 8.8648C17.757 8.89986 17.9782 8.94984 18.1946 9.01391L18.4785 8.05503C18.2199 7.9785 17.9553 7.91868 17.6857 7.8767L17.5318 8.8648ZM17.1088 7.3083V8.37075H18.1088V7.3083H17.1088ZM1.59742 7.8083H17.6088V6.8083H1.59742V7.8083ZM2.09742 14.7994V7.3083H1.09742V14.7994H2.09742ZM4.14468 17.0593C3.05317 17.0593 2.09742 16.0836 2.09742 14.7994H1.09742C1.09742 16.5589 2.42692 18.0593 4.14468 18.0593V17.0593ZM10.626 17.0593H4.14468V18.0593H10.626V17.0593ZM11.3304 18.1818C11.246 17.942 11.173 17.6953 11.1122 17.4424L10.1399 17.6761C10.2086 17.9621 10.2913 18.2417 10.3871 18.5138L11.3304 18.1818ZM4.14468 18.8478H10.8587V17.8478H4.14468V18.8478ZM0.369629 14.7994C0.369629 16.9926 2.02663 18.8478 4.14468 18.8478V17.8478C2.65289 17.8478 1.36963 16.5173 1.36963 14.7994H0.369629ZM0.369629 4.54842V14.7994H1.36963V4.54842H0.369629ZM4.14468 0.5C2.02663 0.5 0.369629 2.3552 0.369629 4.54842H1.36963C1.36963 2.83049 2.65289 1.5 4.14468 1.5V0.5ZM4.14468 2.28854H15.0615V1.28854H4.14468V2.28854ZM2.09742 4.54842C2.09742 3.26419 3.05317 2.28854 4.14468 2.28854V1.28854C2.42692 1.28854 1.09742 2.7889 1.09742 4.54842H2.09742ZM2.09742 6.51976V4.54842H1.09742V6.51976H2.09742ZM17.6088 6.01976H1.59742V7.01976H17.6088V6.01976ZM17.1088 4.54842V6.51976H18.1088V4.54842H17.1088ZM15.0615 2.28854C16.153 2.28854 17.1088 3.26419 17.1088 4.54842H18.1088C18.1088 2.7889 16.7793 1.28854 15.0615 1.28854V2.28854Z"
                              fill="black"
                            />
                          </svg>
                        </Link>
                      </li>
                    </>
                  )}
                  <li>
                    <Link
                      to="/account-settings"
                      className={`${
                        location.pathname.includes("account-settings") &&
                        "active"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 20 20"
                      >
                        <g
                          stroke="#111"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          clipPath="url(#clip0_33_435)"
                        >
                          <path d="M4.756 2.678l1.402-.782a1.759 1.759 0 011.315-.173c.22.057.427.156.607.291.181.135.333.303.446.496.15.266.37.488.639.643a1.773 1.773 0 001.772 0c.268-.155.488-.377.638-.643.232-.387.61-.668 1.054-.783a1.779 1.779 0 011.314.169l1.392.782c.198.113.37.263.508.442a1.664 1.664 0 01.325 1.26c-.035.221-.114.433-.233.623a1.658 1.658 0 00.003 1.689c.153.256.371.47.635.618.263.148.562.226.866.227.46.003.898.182 1.222.5.324.316.506.745.506 1.192v1.574c0 .446-.182.874-.506 1.19a1.752 1.752 0 01-1.222.492 1.764 1.764 0 00-.871.222 1.708 1.708 0 00-.639.619 1.649 1.649 0 00.006 1.693c.229.387.291.847.173 1.28a1.699 1.699 0 01-.803 1.026l-1.403.782a1.758 1.758 0 01-1.317.168 1.743 1.743 0 01-.607-.294 1.697 1.697 0 01-.444-.498 1.714 1.714 0 00-.638-.643 1.774 1.774 0 00-1.772 0 1.714 1.714 0 00-.638.643c-.232.386-.61.667-1.054.782a1.778 1.778 0 01-1.314-.168l-1.403-.782a1.7 1.7 0 01-.809-1.024c-.12-.433-.06-.893.17-1.282a1.658 1.658 0 00-.004-1.688 1.715 1.715 0 00-.635-.618 1.774 1.774 0 00-.866-.228c-.46 0-.9-.176-1.225-.492a1.67 1.67 0 01-.513-1.19V9.219a1.701 1.701 0 01.526-1.208 1.79 1.79 0 011.252-.484c.306.003.606-.072.87-.219.266-.146.487-.358.64-.614a1.649 1.649 0 00.005-1.69 1.654 1.654 0 01-.187-1.292c.058-.217.16-.42.301-.598.14-.177.316-.326.516-.436z"></path>
                          <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_33_435">
                            <path fill="#fff" d="M0 0H20V20H0z"></path>
                          </clipPath>
                        </defs>
                      </svg>
                    </Link>
                  </li>
                </React.Fragment>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
